"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOPPING_CART = void 0;
var SHOPPING_CART = {
  BUTTON__GO_TO_PRODUCTS: 'shoppingCart-button-goToProducts',
  TEXT__PRODUCTS_IN_CART: 'shoppingCart-text-productsInCart',
  TEXT__SUPPLIER_NAME: 'shoppingCart-text-supplierName',
  TEXT__PRODUCT_NAME: 'shoppingCart-text-productName',
  TEXT__PRODUCT_QUANTITY: 'shoppingCart-text-productQuantity',
  TEXT__PRODUCT_PRICE_PER_UNIT: 'shoppingCart-text-productPricePerUnit',
  TEXT__PRODUCT_SKU: 'shoppingCart-text-productSKU',
  TEXT__PRODUCT_AMOUNT: 'shoppingCart-text-productAmount',
  BUTTON__REMOVE_PRODUCT: 'shoppingCart-button-removeProduct',
  BUTTON__SUPPLIER_LEAVE_NOTE: 'shoppingCart-button-leaveNote',
  BUTTON__SUPPLIER_REMOVE_NOTE: 'shoppingCart-button-removeNote',
  TEXTAREA_SUPPLIER_NOTE: 'shoppingCart-textarea-note',
  TEXT__SUPPLIER_SUBTOTAL: 'shoppingCart-text-supplierSubtotal',
  TEXT__SUPPLIER_DELIVERY_FEE: 'shoppingCart-text-supplierDeliveryFee',
  TEXT__SUPPLIER_TAX: 'shoppingCart-text-supplierTax',
  TEXT__SUPPLIER_TOTAL: 'shoppingCart-text-supplierTotal',
  TEXT__WARNING_MOA: 'shoppingCart-text-warningMOA',
  TEXT__WARNING_FRACTIONAL_UNIT: 'shoppingCart-text-warningFractionalUnit',
  TEXT__WARNING_MARKET_PRICE: 'shoppingCart-text-warningMarketPrice',
  TEXT__WARNING_MP_AND_FU: 'shoppingCart-text-warningMarketPriceAndFractionalUnit',
  BUTTON__ORDER_TYPE: 'shoppingCart-button-orderType',
  BUTTON__STANDING_DATE: 'shoppingCart-button-standingDate',
  INPUT__REPAT_INTERVAL: 'shoppingCart-button-repeatInterval',
  BUTTON__DELIVERY_DATE: 'shoppingCart-button-deliveryDate',
  TEXT__GRAND_TOTAL: 'shoppingCart-text-grandTotal',
  BUTTON__SUBMIT_ORDER_REQUEST: 'shoppingCart-button-submitOrderRequest',
  BUTTON__CONFIRM_ORDER_CANCEL: 'shoppingCart-button-confirmOrderCancel',
  BUTTON__CONFIRM_ORDER_SUBMIT: 'shoppingCart-button-confirmOrderSubmit'
};
exports.SHOPPING_CART = SHOPPING_CART;